var exports = {
  "kL": "AppSkeleton.module__container___U1p0Qk",
  "ER": "AppSkeleton.module__containerExiting___U1p0Qk",
  "A1": "AppSkeleton.module__containerGuilds___U1p0Qk",
  "BG": "AppSkeleton.module__containerRailless___U1p0Qk",
  "w_": "AppSkeleton.module__containerReserveUserArea___U1p0Qk",
  "u5": "AppSkeleton.module__containerReserveMobileBottomNav___U1p0Qk",
  "aF": "AppSkeleton.module__outlineFrame___U1p0Qk",
  "Qs": "AppSkeleton.module__content___U1p0Qk",
  "iW": "AppSkeleton.module__main___U1p0Qk",
  "NK": "AppSkeleton.module__mainSidebarless___U1p0Qk",
  "qy": "AppSkeleton.module__contentColumn___U1p0Qk",
};

module.exports = exports;
